import { render, staticRenderFns } from "./reorder_reminder.vue?vue&type=template&id=7700fbf5&scoped=true"
import script from "./reorder_reminder.vue?vue&type=script&lang=js"
export * from "./reorder_reminder.vue?vue&type=script&lang=js"
import style0 from "./reorder_reminder.vue?vue&type=style&index=0&id=7700fbf5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7700fbf5",
  null
  
)

export default component.exports